@if (!isDataInitialized && !isResourceAccount()) {
  <div class="row mb-3">
    <label class="ziro-forms-label col-form-label col-lg-3 text-lg-end" [attr.id]="'calling-queue-button-button'">
      {{ 'tkey;microsoft_360.view.teams.call_queues.call_queue_membership.label' | translate }}
    </label>
    <ziro-button
      [class]="'col-lg-3'"
      [dataAutomation]="'calling-queue-button'"
      [buttonStyle]="ButtonStyles.OUTLINE_PRIMARY"
      [label]="'tkey;microsoft_360.view.teams.call_queues.call_queue_membership.button' | translate"
      [icon]="ziroIcons.CALL_QUEUE"
      [iconPending]="ziroIcons.SAVING"
      [isPending]="isFetchingQueueData"
      (clicked)="getCallQueues()"
    ></ziro-button>
  </div>
}
<ziro-select [class]="'fade-in'" [hidden]="!isDataInitialized" [fieldId]="'callQueues'"></ziro-select>
